<template>
  <a-modal
      title="修改密码"
      :visible="visible"
      :width="700"
      @cancel="handleCancel"
      @ok="handleSubmit"
      :maskClosable="false">
    <a-form-model ref="targetForm" :model="form" :rules="rules" v-bind="layout">
      <a-form-model-item has-feedback label="旧密码" prop="oldPassword">
        <a-input v-model="form.oldPassword" type="password" autocomplete="off"/>
      </a-form-model-item>
      <a-form-model-item has-feedback label="新密码" prop="newPassword">
        <a-input v-model="form.newPassword" type="password" autocomplete="off"/>
      </a-form-model-item>
      <a-form-model-item has-feedback label="确认密码" prop="checkPassword">
        <a-input v-model="form.checkPassword" type="password" autocomplete="off"/>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>

import {HttpMixins} from "@/mixins/http-mixins";

export default {
  name: "UpdatePassword",
  mixins: [HttpMixins],
  data() {
    return {
      visible: false,
      form: {},
      layout: {
        labelCol: {span: 6},
        wrapperCol: {span: 16},
      },
      rules: {
        oldPassword: [{validator: this.validateOldPass, trigger: 'change'}],
        newPassword: [{validator: this.validateNewPass, trigger: 'change'}],
        checkPassword: [{validator: this.validateCheckPass, trigger: 'change'}],
      },
      url: {
        updatePassword: window._CONFIG['domainURL'] + "/user/updatePassword",
      }
    }
  },
  methods: {
    show() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.targetForm.resetFields();
        this.form = {};
      });
    },
    handleCancel() {
      this.visible = false;
    },
    handleSubmit() {
      const that = this;
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            that.handleCancel();
            that.$message.success("修改成功,请重新登录");
          } else {
            that.$message.error(response.msg);
          }
        }
      }
      this.$refs.targetForm.validate(valid => {
        if (valid) {
          that.$axios.put(that.url.updatePassword, that.form, {headers: that.headers})
              .then(handleSuccess)
              .catch((error) => that.catchError(error).then(handleSuccess))
        }
      });
    },
    validateOldPass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入旧密码'));
      } else {
        callback();
      }
    },
    validateNewPass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (this.form.checkPassword) {
          this.$refs.targetForm.validateField('checkPassword');
        }
        callback();
      }
    },
    validateCheckPass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再输入密码'));
      } else if (value !== this.form.newPassword) {
        callback(new Error("密码不一致"));
      } else {
        callback();
      }
    }
  }
}
</script>

<style scoped>

</style>
